module.exports = __webpack_public_path__ + "static/media/cloud.93563b97.svg";